import { Icon } from '@/shared/Icon';
import { Reference } from '@/types/models';

type AnnotationItemProps = Pick<Reference, 'link' | 'type' | 'resource'>;

export const AnnotationItem = ({ link, type, resource }: AnnotationItemProps): JSX.Element => (
  <a className="pl-3 text-sm font-normal" href={link?.toString()} target="_blank">
    <div className="flex justify-between">
      <span>
        <b className="font-semibold">
          {type} ({resource})
        </b>
      </span>
      <Icon name="arrow" className="h-6 w-6 fill-font-500" />
    </div>
  </a>
);
